import { ConnectionMethod } from "@/websocket/model/enums/connection-method";
import { MessageType } from "@/websocket/model/enums/message-type";
import { Channel } from "@/websocket/model/channel";
import { normalizeLength, channelsToMessage } from "@/websocket/utils/messages";
import { isV2Protocol } from "@/websocket/composables/use-openbet-ws-client";

interface IRequest {
    type: MessageType;
    toString: () => void;
}

export class Request implements IRequest {
    constructor(public type: MessageType) {}
}

export class ConnectionRequest extends Request {
    public connectionMethod: ConnectionMethod = ConnectionMethod.Persistent; // We use persistent 'P' connection method only, not 'L' long-poll
    constructor(public token: string) {
        super(MessageType.Connect);
    }
    toString(): string {
        const tokenLength = normalizeLength(this.token.length);
        const version = isV2Protocol() ? "02" : "";
        return this.type + version + this.connectionMethod + tokenLength + this.token;
    }
}

export class PingRequest extends Request {
    constructor(public id: number) {
        super(MessageType.Ping);
    }
    toString(): string {
        return this.type + normalizeLength(this.id);
    }
}

export class SubscribeRequest extends Request {
    constructor(
        public channels: Channel[],
        // Need to add some mechanism to add last message id
        public messageId: string = "!!!!!!!!!!",
    ) {
        super(MessageType.Subscribe);
    }
    toString(): string {
        const channelNo = normalizeLength(this.channels.length);
        const channelsMessage = channelsToMessage(this.channels);
        return this.type + channelNo + channelsMessage + this.messageId;
    }
}

export class UnsubscribeRequest extends Request {
    constructor(public channels: Channel[]) {
        super(MessageType.Unsubscribe);
    }
    toString(): string {
        const channelNo = normalizeLength(this.channels.length);
        const channelsMessage = channelsToMessage(this.channels);
        return this.type + channelNo + channelsMessage;
    }
}
